<template>
  <v-container id="payment-list">
    <v-row>
      <v-col cols="8" md="8" class="breadcrumbs">
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <app-consultant-combobox :filter="filter"></app-consultant-combobox>
      </v-col>

      <v-col>
        <v-text-field
          v-model="filter.dataInicialString"
          v-mask="'##/##/####'"
          label="Data Inicial"
          clearable
        ></v-text-field>
      </v-col>

      <v-col>
        <v-text-field
          v-model="filter.dataFinalString"
          v-mask="'##/##/####'"
          label="Data Final"
          clearable
        ></v-text-field>
      </v-col>

      <v-col>
        <v-select
          v-model="filter.statusId"
          :items="statusProcessosPagamento"
          item-text="text"
          item-value="value"
          label="Status"
          clearable
        ></v-select>
      </v-col>

      <v-col>
        <v-btn outlined color="primary" class="ml-3" @click="listByFilter()">
          <span>Filtrar</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payments"
          item-key="relatorioGestaoPagamentoId"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item="props">
            <tr
              :class="{
                evidenciada: props.item.statusId === 1,
                evidenciar: props.item.statusId === 2,
                rejeitada: props.item.statusId === 0,
              }"
            >
              <td>
                <a @click="clickRow(props)">{{
                  props.item.relatorioGestaoPagamentoId
                }}</a>
              </td>
              <td>
                <a @click="clickRow(props)">{{ props.item.usuario.nome }}</a>
              </td>
              <td>
                <v-btn
                  v-if="props.item.contrato"
                  icon
                  small
                  color="primary"
                  @click.stop="openContractModal(props.item.contrato)"
                >
                  <v-icon>mdi-information-outline</v-icon>
                </v-btn>
                <span v-else class="text--disabled">N/A</span>
              </td>
              <td>
                <a @click="clickRow(props)">
                  <span v-if="props.item.statusId === 0">Não analisado</span>
                  <span v-if="props.item.statusId === 1">Aprovado</span>
                  <span v-if="props.item.statusId === 2">Reprovado</span>
                </a>
              </td>
              <td>
                <template
                  v-if="
                    props.item.statusId === 2 &&
                    (isFullAdmin ||
                      (config.podeAnalisarRelatorio &&
                        groupsConfig.podeAnalisarRelatorio) ||
                      props.item.usuarioId === user.usuarioId)
                  "
                >
                  {{ transformValue(props.item.observacoes) }}
                </template>
              </td>
              <td>
                <a @click="clickRow(props)">{{
                  props.item.criacao | moment("DD/MM/YYYY")
                }}</a>
              </td>
              <td>
                <a @click="clickRow(props)">{{ props.item.horas }}</a>
              </td>
              <td>
                <v-btn
                  v-if="props.item.statusId === 1"
                  color="info"
                  outlined
                  text
                  @click="relatorioSGF(props)"
                  >Relatório SGF</v-btn
                >
              </td>
              <td>
                <v-btn
                  v-if="props.item.statusId === 1 && isFullAdmin"
                  color="info"
                  outlined
                  text
                  @click="relatorioSGFEmail(props)"
                  >Receber E-mail</v-btn
                >
              </td>
              <td>
                <app-modal-delete
                  v-if="podeExcluirProcessoPagamento(props.item)"
                  :payload="props.item"
                  @onDelete="loadPayments"
                >
                  <template v-slot:title>
                    Deletar Processo de Pagamento
                  </template>
                </app-modal-delete>
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <span> Nenhum processo de pagamento retornado </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <app-modal-analyse
      :dialog="openModal"
      :payload="selectedReport"
      @onCloseReport="onCloseModal"
    >
    </app-modal-analyse>

    <app-modal-report-sgf
      :dialog="openModalSGF"
      :payload="selectedReport"
      @onCloseReport="onCloseModalSGF"
    >
    </app-modal-report-sgf>

    <!-- Modal do Contrato -->
    <v-dialog v-model="contractModalOpen" max-width="700px">
      <v-card>
        <v-card-title class="headline primary white--text">
          <v-icon left color="white">mdi-file-document-outline</v-icon>
          Informações do Contrato
        </v-card-title>
        <v-card-text class="pa-6">
          <ContractInfoCard
            :contractData="selectedContract"
            @close="closeContractModal"
          ></ContractInfoCard>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeContractModal"> Fechar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { paymentReportManagementAPI } from "@/modules/payment-management";
import { mapActions } from "vuex";
import { AppConsultantCombobox } from "@/modules/user";
import AppModalAnalyse from "./ModalAnalyse";
import AppModalReportSgf from "./ModalReportSGF";
import AppModalDelete from "./ModalDelete";
import { mapGetters } from "vuex/dist/vuex.common.js";
import moment from "moment";
import ContractInfoCard from "../../../components/ContractInfoCard.vue";
export default {
  components: {
    AppConsultantCombobox,
    AppModalAnalyse,
    AppModalReportSgf,
    ContractInfoCard,
    AppModalDelete,
  },
  data() {
    return {
      headers: [
        {
          text: "#",
          value: "relatorioGestaoPagamentoId",
        },
        {
          text: "Usuário",
          value: "usuario.nome",
        },
        {
          text: "Contrato",
          value: "contrato",
          sortable: false,
        },
        {
          text: "Status",
          value: "statusId",
        },
        {
          text: "Motivo da rejeição",
          value: "observacoes",
        },
        {
          text: "Criação",
          value: "criacao",
        },
        {
          text: "Horas",
          value: "horas",
        },
        {
          text: "Relatório",
          value: "relatorio",
          sortable: false,
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ],

      user: JSON.parse(localStorage.getItem("user")),

      payments: [],
      filter: {
        usuarioId: null,
        dataInicial: null,
        dataFinal: null,
        statusId: 0,
      },
      statusProcessosPagamento: [
        { text: "Não analisado", value: 0 },
        { text: "Aprovado", value: 1 },
        { text: "Rejeitado", value: 2 },
        { text: "Todos", value: null },
      ],
      openModal: false,
      selectedReport: {},
      openModalSGF: false,
      contractModalOpen: false,
      selectedContract: null,
      breadcrumbs: [
        {
          text: "Home",
          disabled: false,
          href: "cidade",
        },
        {
          text: "Processos de Pagamento",
          disabled: true,
          href: "gestao-pagamento",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["isAdmin", "isFullAdmin", "config", "groupsConfig"]),
    podeReenviarEmailProcessoPagamento() {
      return (
        this.isFullAdmin ||
        (this.config?.podeReenviarEmailProcessoPagamento &&
          this.groupsConfig?.podeReenviarEmailProcessoPagamento)
      );
    },
    verTipoSolucaoProcessoPagamento() {
      return (
        this.isFullAdmin ||
        (this.config?.verTipoSolucaoProcessoPagamento &&
          this.groupsConfig?.verTipoSolucaoProcessoPagamento)
      );
    },
  },
  mounted() {
    this.listByFilter();
  },
  methods: {
    ...mapActions(["setLoading"]),
    transformValue(item) {
      if (item && item.length > 20) {
        return item.substring(0, 20) + "...";
      }

      return item;
    },
    temPermissaoExcluirProcessoPagamento(campo) {
      return (
        this.isAdmin ||
        this.isFullAdmin ||
        (this.config?.[campo] && this.groupsConfig?.[campo])
      );
    },
    podeExcluirProcessoPagamento(item) {
      if (!item) {
        return false;
      }

      switch (item.statusId) {
        case 0:
          return this.temPermissaoExcluirProcessoPagamento(
            "podeExcluirProcessoPagamentoEmAnalise"
          );
        case 1:
          return this.temPermissaoExcluirProcessoPagamento(
            "podeExcluirProcessoPagamentoAprovado"
          );
        case 2:
          return this.temPermissaoExcluirProcessoPagamento(
            "podeExcluirProcessoPagamentoRejeitado"
          );
        default:
          return false;
      }
    },
    loadPayments() {
      this.listByFilter();
    },
    listByFilter() {
      this.setLoading(true);
      paymentReportManagementAPI
        .listByFilter(this.filter)
        .then((resp) => {
          this.payments = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao listar processos de pagamento");
        });
    },
    onCloseModal(needReload) {
      this.openModal = false;
      if (needReload) this.listByFilter();
    },
    clickRow(data) {
      this.selectedReport = data.item;
      this.openModal = true;
    },
    relatorioSGF(data) {
      if (this.$store.state.uf == "SP") {
        this.relatorioSGFSP(data);
        return;
      }
      this.setLoading(true);
      paymentReportManagementAPI
        .downloadGestaoPagamento(
          data.item.relatorioGestaoPagamentoId,
          this.verTipoSolucaoProcessoPagamento
        )
        .then((resp) => {
          let blob = new Blob([resp.data], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `Relatorio_Pagamento_${data.item.codigoContratacao}_${data.item.usuario.nome}.pdf`;
          link.click();
          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter anexo");
        });
    },
    relatorioSGFSP(data) {
      this.selectedReport = data.item;
      this.setLoading(true);
      paymentReportManagementAPI
        .downloadGestaoPagamentoSP(data.item.relatorioGestaoPagamentoId)
        .then((resp) => {
          let blob = new Blob([resp.data], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `Relatorio_Pagamento_${data.item.codigoContratacao}_${data.item.usuario.nome}.pdf`;
          link.click();
          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter anexo");
        });
    },
    onCloseModalSGF() {
      this.openModalSGF = false;
    },
    openContractModal(contract) {
      this.selectedContract = contract;
      this.contractModalOpen = true;
    },
    closeContractModal() {
      this.contractModalOpen = false;
      this.selectedContract = null;
    },
    relatorioSGFEmail(payload) {
      paymentReportManagementAPI
        .receiveEmail(payload.item.relatorioGestaoPagamentoId)
        .then((resp) => {
          this.setLoading(false);
          this.$notification.success("E-mail enviado com sucesso");
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao enviar e-mail");
        });
    },
    removerProcessoDePagamento(payload) {
      paymentReportManagementAPI
        .delete(payload.item.relatorioGestaoPagamentoId)
        .then((resp) => {
          this.listByFilter();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao excluir processo de pagamento");
        });
    },
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
